import request from '@/utils/request'

// 조회
export function getPreventRecurrenceProcedure(params, isProgress) {
  return request({
    url: `/api/getPreventRecurrenceProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 예시
export function getPreventRecurrenceProcedureSample(isProgress) {
  return request({
    url: `/api/getPreventRecurrenceProcedureSample`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 저장
export function savePreventRecurrenceProcedure(params, isProgress) {
  return request({
    url: `/api/savePreventRecurrenceProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
// 삭제
export function deletePreventRecurrenceProcedure(params, isProgress) {
  return request({
    url: `/api/deletePreventRecurrenceProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}
// 출력
export function getPreventRecurrenceProcedureReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: '/api/getPreventRecurrenceProcedureReport',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}